import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { DeliveryAddressesFragmentDoc } from './DeliveryAddresses.generated'
import { PurchasePlusFeatureFlagsFragmentDoc } from './FeatureFlags.generated'
import { FinanceFlagsFragmentDoc } from './FinanceFlags.generated'
import { InvoiceThresholdFragmentDoc } from './InvoiceThreshold.generated'
import * as Types from './purchasePlus_graphql'

export const GetOrganisationDocument = gql`
  query GetOrganisation($organisationId: Int!, $isAdmin: Boolean = false) {
    organisation(id: $organisationId) {
      id
      name
      businessName
      businessNumber
      businessUnit
      shortDescription
      description
      email
      telephone
      departmentCode
      corporateCode
      companyBrand
      postalAddressLine1
      postalAddressLine2
      postalAddressCountry
      postalAddressCity
      postalAddressStateProvince
      postalAddressPostalCode
      billingAddressLine1
      billingAddressLine2
      billingAddressCountry
      billingAddressCity
      billingAddressStateProvince
      billingAddressPostalCode
      billingAddressIsPostalAddress
      legalEntity
      createdAt
      emailApiInvoiceCopy
      subscription @include(if: $isAdmin)
      featureFlags {
        ...PurchasePlusFeatureFlags
      }
      nearestLegalEntity {
        id
        name
      }
      billingGroup @include(if: $isAdmin) {
        id
        name
        subscription
      }
      isASupplier
      isAPurchaser
      parent {
        id
        name
      }
      owner {
        id
        name
      }
      isVerified
      shopSquareLogoUrl
      shopBannerUrl
      shopHexCode
      shopOverlayLogoUrl
      enablePublicShop
      ... on Supplier {
        defaultCurrency
        supplierIpsiSetting @include(if: $isAdmin) {
          id
          configId
          userName
          supplierSecret
        }
      }
      ... on Purchaser {
        invoiceWorkflow {
          id
          name
        }
        accountsPayableSystem {
          id
          name
          financeExportFormat {
            id
            name
          }
          financeExportVariant {
            id
            name
          }
        }
        paperlessInvoicingIdentityEmail
        holder {
          id
          purchaser {
            id
            name
          }
        }
        invoiceThresholds {
          edges {
            node {
              ...InvoiceThreshold
            }
          }
        }
        financeFlagSettings {
          ...FinanceFlags
        }
        defaultDeliveryAddress {
          ...DeliveryAddresses
        }
        termsAndConditions
        confirmationInstructions
        deliveryInstructions
        timeZone
        purchaseOrderCopyEmail
        autoCloseOrder
        accountsEmail
        logoUrl
        signatureUrl
      }
    }
  }
  ${PurchasePlusFeatureFlagsFragmentDoc}
  ${InvoiceThresholdFragmentDoc}
  ${FinanceFlagsFragmentDoc}
  ${DeliveryAddressesFragmentDoc}
` as unknown as DocumentNode<Types.GetOrganisationQuery, Types.GetOrganisationQueryVariables>
